import { APP_IDS, APP_URLS } from '../../constants/applications';

export interface ApplicationPickerItem {
  id: string;
  name?: string;
  icon: string;
  url: string;
  cssClass?: string;
  alwaysVisible?: boolean;
}

export const applicationPickerItems: ApplicationPickerItem[] = [
  {
    id: APP_IDS.HOME,
    name: 'Home',
    icon: 'house',
    url: APP_URLS[APP_IDS.HOME],
    alwaysVisible: true,
  },
  {
    id: APP_IDS.CLOUD,
    name: 'Cloud',
    icon: 'cloud',
    url: APP_URLS[APP_IDS.CLOUD],
  },
  {
    id: APP_IDS.MARKETPLACE,
    icon: 'shop',
    url: APP_URLS[APP_IDS.MARKETPLACE],
  },
  {
    id: APP_IDS.BRAINBOX,
    icon: 'brain-circuit',
    url: APP_URLS[APP_IDS.BRAINBOX],
  },
  {
    id: APP_IDS.TMM,
    name: 'Maintenance',
    icon: 'tools',
    url: APP_URLS[APP_IDS.TMM],
    cssClass: 'section-end',
  },
  {
    id: APP_IDS.COMMAND_CENTER,
    name: 'Command Center',
    icon: 'display-chart-up',
    url: APP_URLS[APP_IDS.COMMAND_CENTER],
  },
  {
    id: APP_IDS.SETUP,
    name: 'Setup',
    icon: 'gear',
    url: APP_URLS[APP_IDS.SETUP],
    cssClass: 'section-end',
    alwaysVisible: true,
  },
  {
    id: APP_IDS.ACCOUNT_SETTINGS,
    name: 'Account Settings',
    icon: 'building-user',
    url: APP_URLS[APP_IDS.ACCOUNT_SETTINGS],
    alwaysVisible: true,
  },
];
